export default __webpack_public_path__ + "static/media/man-and-child.43825ff7.jpg";